// @ts-ignore
import React, { useState } from "react";
import styles from "./Contract.module.scss";
import {AmbulanceBlue, AmbulanceIcon, AmbulanceNewIcon, TrashIcon, UploadIcon} from "../../../assets";

const UploadAgreementDocuments = ({selectedFiles, setSelectedFiles}) => {

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const newFiles = Array.from(event.target.files);

      // Prevent duplicate files by name + size
      const existingFileSignatures = new Set(
        selectedFiles.map((file) => file.name + file.size)
      );

      const filteredNewFiles = newFiles.filter(
        (file) => !existingFileSignatures.has(file.name + file.size)
      );

      setSelectedFiles((prev) => [...prev, ...filteredNewFiles]);

      // Reset input so same file can be selected again later
      event.target.value = "";
    }
  };

  const handleRemoveFile = (indexToRemove: number) => {
    setSelectedFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  return (
    <div
      style={{
        overflow: "auto",
        // width: "100%",
        height: "62vh",
        // paddingLeft: 24,
        // paddingRight: 24,
        marginTop: 24,
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: 16,
        display: "flex",
        flexWrap: "wrap",
      }}
    >
      {/* Upload Button */}

        <label
          style={{ display: "contents" }}
          htmlFor="img-upload"
          className={styles.imgUploadWrapper}
        >
          <div
            style={{
              width: selectedFiles && selectedFiles.length> 0 ? "49%" : "100%",
              // flex: "1 1 0",
              height: 296,
              padding: 16,
              background: "#F1F6FF",
              overflow: "hidden",
              borderRadius: 12,
              outline: "1px #E7E7E7 solid",
              outlineOffset: "-1px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 12,
              display: "inline-flex",
              cursor: "pointer"
            }}
          >
          <UploadIcon />
          <span>Загрузить документы</span>
          <input
            id="img-upload"
            multiple
            accept=".pdf, .doc, .docx"
            onChange={handleFileChange}
            className="hidden"
            type="file"
          />
          </div>
        </label>

      {/* Preview Each Uploaded File */}
      {selectedFiles.map((file, idx) => (
        <div
          key={idx}
          style={{
            width: "49%",
            height: 296,
            padding: 16,
            background: "#F1F6FF",
            overflow: "hidden",
            borderRadius: 12,
            outline: "1px #E7E7E7 solid",
            outlineOffset: "-1px",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 12,
            display: "inline-flex",
            position: "relative",
          }}
        >
          <div style={{width: '100%', paddingLeft: 16, paddingRight: 16, paddingTop: 12, paddingBottom: 12, background: 'white', borderRadius: 8, outline: '1px #E7E7E7 solid', outlineOffset: '-1px', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 4, display: 'inline-flex'}}>
            <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', alignItems: 'center', gap: 12, display: 'inline-flex'}}>
             <AmbulanceNewIcon/>
              <div style={{flex: '1 1 0', justifyContent: 'center', display: 'flex', flexDirection: 'column', color: '#192233', fontSize: 14, fontFamily: 'Manrope', fontWeight: '700', wordWrap: 'break-word'}}>{file.name}</div>
              <TrashIcon  onClick={() => handleRemoveFile(idx)} className={styles.trash}/>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UploadAgreementDocuments;
